import React from 'react';
import { Image } from 'react-bootstrap';

import './style.scss';

type LogoProps = {
  imageSrc: string;
  text?: string;
  width?: number;
  height?: number;
  className?: string;
  variant?: 'rounded' | 'rounded-circle' | 'square';
  style?: object;
  inverse?: boolean;
};

const Logo: React.FunctionComponent<LogoProps> = ({
  imageSrc,
  text,
  width = 30,
  height,
  className,
  variant = 'rounded',
  style,
  inverse,
}) => {
  if (imageSrc) {
    return (
      <>
        <Image
          width={width}
          height={height ? height : null}
          src={imageSrc}
          className={`${className} bg-white ${variant}`}
          style={style}
        />
        <span className={`${className}`} />
      </>
    );
  }

  return (
    <div
      className={`logo-placeholder ${className} ${variant} ${inverse ? 'inverse text-primary' : ''}
        text-capitalize font-weight-bold d-flex justify-content-center align-items-center`}
      style={{ width, height, ...style }}
    >
      {(text || '')[0]}
    </div>
  );
};

export default Logo;
